<template lang="html">
  <div class="logo">
    <router-link to="/" @click.native="close">
      <div class="logo-svg"></div>
      <div class="logo-title"></div>
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'Logo',
  methods: {
    close () {
      this.$emit('clicked')
    }
  }
}
</script>

<style lang="scss" scoped>

@import '../scss/settings';
@import '../scss/mixins';

.logo-svg {
  z-index: 99;
  width: 100px;
  height: 53px;
  background-image: url('../assets/logo.svg');
  background-size: contain;
  position: absolute;
  top: $padding;
  left: $padding;
}

.logo-title {
  z-index: 99;
  width: 129px;
  height: 53px;
  background-image: url('../assets/title5.svg');
  background-size: contain;
  background-repeat: no-repeat;
  position: absolute;
  top: $padding;
  left: $padding + 115px;
}

</style>



// WEBPACK FOOTER //
// src/components/Logo.vue